"use strict";

define('uikit/channel',['marionette', 'backbone', 'backbone.radio'], function (Mn, Backbone, Radio) {
  return Radio.channel('uikit');
});

